module.exports = __webpack_public_path__ + "static/img/2.f88a2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-1/2.jpg
// module id = rkL7
// module chunks = 1